// extracted by mini-css-extract-plugin
export var forLabel = "trialDiagram-module--forLabel--ec218";
export var icon = "trialDiagram-module--icon--04ae9";
export var item = "trialDiagram-module--item--2a190";
export var itemCenter = "trialDiagram-module--item-center--f36ac";
export var label = "trialDiagram-module--label--c3348";
export var number = "trialDiagram-module--number--f9fb7";
export var wrapper = "trialDiagram-module--wrapper--9dfb6";